module.exports = __webpack_public_path__ + "img/ryno_white.ddb45b6e.svg";